
import { Button, Flex } from "components-lib";

/**
 * NavigationTabs Component
 * Handles the main navigation tabs for the doctor dashboard
 * Includes Consultations, Appointments, Patient List, Reports, and Bills tabs
 * Supports compact mode for focus mode display
 */
const NavigationTabs = ({
  consultable,
  appoinmentable,
  showPatientList,
  showReports,
  showBills,
  onConsultationsClick,
  onAppointmentsClick,
  onPatientListClick,
  onReportsClick,
  onBillsClick,
  ric,
  compact = false, // New prop for compact mode
}) => {
  console.log("🔴" + ric);

  // Adjust sizing based on compact mode
  const buttonSize = compact ? "sm" : "md";
  const buttonPx = compact ? 4 : 6;
  const gap = compact ? 1 : 2;

  return (
    <Flex gap={gap} align="center">
      <Button
        variant={consultable ? "solid" : "outline"}
        colorScheme={consultable ? "blue" : "gray"}
        onClick={onConsultationsClick}
        size={buttonSize}
        borderWidth="1px"
        fontWeight={1000}
        px={buttonPx}
      >
        Consultations
      </Button>
      <Button
        variant={appoinmentable ? "solid" : "outline"}
        colorScheme={appoinmentable ? "blue" : "gray"}
        onClick={onAppointmentsClick}
        size={buttonSize}
        borderWidth="1px"
        fontWeight={1000}
        px={buttonPx}
      >
        Appointments
      </Button>
      <Button
        variant={showPatientList ? "solid" : "outline"}
        colorScheme={showPatientList ? "blue" : "gray"}
        onClick={onPatientListClick}
        size={buttonSize}
        fontWeight={1000}
        px={buttonPx}
      >
        Patient List
      </Button>

      {/* Show Reports button only for owner or admin (hide if undefined, employee or frontdesk) */}
      {["owner", "admin", "Admin"].includes(ric) && (
        <Button
          variant={showReports ? "solid" : "outline"}
          colorScheme={showReports ? "blue" : "gray"}
          onClick={onReportsClick}
          size={buttonSize}
          fontWeight={1000}
          px={buttonPx}
        >
          Reports
        </Button>
      )}

      <Button
        variant={showBills ? "solid" : "outline"}
        colorScheme={showBills ? "blue" : "gray"}
        onClick={onBillsClick}
        size={buttonSize}
        fontWeight={1000}
        px={buttonPx}
      >
        Bills
      </Button>
    </Flex>
  );
};

export default NavigationTabs;